import React from "react";
import Button from "../../Global Components/Button";

function HeaderText() {
  return (
    <div className="headerTxtContainer">
      <h1>cyber security</h1>
      <h3>is much more than a matter of information technology</h3>
      <Button />
    </div>
  );
}

export default HeaderText;
